import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import type { PushNotificationService } from '../types/push-notification-service.interface';
import type { NotificationPayload } from '../types/notification-types';

export class FirebasePushService implements PushNotificationService {
  private messaging: any;
  private tokenRefreshCallbacks: ((token: string) => void)[] = [];
  private messageCallbacks: ((message: any) => void)[] = [];
  private actionCallbacks: ((payload: NotificationPayload) => void)[] = [];
  private currentToken: string | null = null;

  async initialize(): Promise<void> {
    this.messaging = getMessaging();

    // Setup message listener
    onMessage(this.messaging, (payload) => {
      this.messageCallbacks.forEach((cb) => cb(payload));
    });
  }

  async requestPermission(): Promise<boolean> {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  async getToken(): Promise<string | null> {
    try {
      const token = await getToken(this.messaging, {
        vapidKey: import.meta.env.VITE_FIREBASE_WEB_PUSH_KEY as string,
      });
      this.currentToken = token;
      return token;
    } catch (error) {
      console.error('Error getting Firebase token:', error);
      return null;
    }
  }

  onTokenRefresh(callback: (token: string) => void): void {
    this.tokenRefreshCallbacks.push(callback);
  }

  onMessage(callback: (message: any) => void): void {
    this.messageCallbacks.push(callback);
  }

  onAction(callback: (payload: NotificationPayload) => void): void {
    this.actionCallbacks.push(callback);
  }

  // Called when user clicks in-app notification UI (foreground)
  triggerAction(payload: NotificationPayload): void {
    this.actionCallbacks.forEach((cb) => cb(payload));
  }

  cleanup(): void {
    this.tokenRefreshCallbacks = [];
    this.messageCallbacks = [];
    this.actionCallbacks = [];
    this.currentToken = null;
  }
}
